import styled from "@emotion/styled";
import { FlexRow, H2, HeadingGroup, Link, Stack } from "atoms";
import { useFeed } from "../api/usePosts";
import { Feed } from "./Feed";

const homeFeedParams = new URLSearchParams({ perPage: "4" });

/**
 * Most recent artist updates (no filters, up to 4 showing)
 */
function HomePageFeed() {
  const { data } = useFeed(homeFeedParams);
  const posts = data?.pages?.[0].data ?? [];

  return (
    <Stack as="section" gap="md">
      <FlexRow alignItems="flex-end" justifyContent="space-between">
        <HeadingGroup>
          <small>Artist Updates</small>
          <H2>Hear the latest from Hug Artists</H2>
        </HeadingGroup>
        <Link to="/artist-updates" variant="primary" size="xs">
          All Artist Updates
        </Link>
      </FlexRow>

      <SFeed posts={posts} showArtist />
    </Stack>
  );
}

const SFeed = styled(Feed)(({ theme }) => ({
  gap: "1rem",
  [theme.breakpoints.tablet]: {
    gridTemplateColumns: `repeat(2, calc(50% - (${theme.spacing.gap} / 2)))`,
  },
  [theme.breakpoints.desktop]: {
    gridTemplateColumns: `repeat(3, calc((100% / 3) - (${theme.spacing.gap} / 3)))`,
    "&>div:nth-of-type(4)": {
      display: "none",
    },
  },
  [theme.breakpoints.desktopLarge]: {
    gridTemplateColumns: `repeat(4, calc(25% - (${theme.spacing.gap} * .375)))`,
    "&>div:nth-of-type(4)": {
      display: "flex",
    },
  },
}));

export { HomePageFeed };
